import { render, staticRenderFns } from "./RangeOfMotionBehaviorEditor.vue?vue&type=template&id=b4a40b4c&scoped=true&"
import script from "./RangeOfMotionBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./RangeOfMotionBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./RangeOfMotionBehaviorEditor.vue?vue&type=style&index=0&id=b4a40b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a40b4c",
  null
  
)

export default component.exports